import type { Step } from 'react-joyride';

import { colors } from '@cobliteam/base-components/src/styles/colors';

import { ContentTour, TitleTour } from '../../../components/Tour';

const commonConfig = {
  spotlightPadding: 10,
  disableBeacon: true,
  styles: {
    spotlight: {
      border: `2px solid ${colors.primary.default}`,
      borderRadius: '10px',
    },
  },
};

const steps: Step[] = [
  {
    ...commonConfig,
    target: 'div[data-teste=Excessos-de-velocidade-da-via]',
    placement: 'left',
    title: (
      <TitleTour
        title='Alerta quando um veículo excede o limite de velocidade de uma via'
        description='Defina a gravidade da infração e o tempo acima da velocidade para receber alertas quando os veículos estiverem acima da velocidade limite da via.'
      />
    ),
    content: <ContentTour />,
  },
  {
    ...commonConfig,
    target: 'div[data-teste=Velocidade-do-veículo]',
    placement: 'left',
    title: (
      <TitleTour
        title='Alerta quando o veículo está acima da velocidade limite permitida pela frota'
        description='Defina o tempo acima da velocidade para receber alertas quando os veículos estiverem acima da velocidade limite estabelecida no cadastro do veículo.'
      />
    ),
    content: <ContentTour />,
  },
  {
    ...commonConfig,
    target: 'div[data-teste=Motor-ocioso]',
    placement: 'left',
    title: (
      <TitleTour
        title='Alerta quando um veículo está há um tempo com o motor ocioso'
        description='Defina a partir de quanto tempo de motor ocioso deseja ser alertado, e se quiser, selecione grupos específicos para o alerta.'
      />
    ),
    content: <ContentTour />,
  },
];

export default steps;
